module.exports = __webpack_public_path__ + "static/grafika2@2x-3b844825adba134b064897d370c4434e.png";